<template>
	<figure
		:class="`element element--${type}`"
		:element-translation="elementTranslation"
		:media-id="mediaId"
		:media-active="mediaActive"
		:alt="altText"
	>
		<ElementSubIcon name="media" />
		<figcaption class="element__caption element__caption--basic">
			<h3 class="element__caption__headline" :aria-label="ariaTitle">{{ title ? title : '' }}</h3>

			<p
				class="element__caption__text element__caption__text--description"
				aria:role="text"
				:aria-label="ariaDescription"
			>
				{{ description ? description : '' }}
			</p>
			<p
				v-if="typeof altText !== 'undefined'"
				class="element__caption__text element__caption__text--alt"
				aria:role="text"
				:aria-label="ariaAttribution"
			>
				{{ altText ? altText : '' }}
			</p>
			<time
				v-if="typeof pastTime !== 'undefined'"
				class="element__caption__time element__caption__time--pastTime"
				>{{ readAbleTime(pastTime) }}</time
			>
			<time
				v-if="typeof remainingTime !== 'undefined'"
				class="element__caption__time element__caption__time--remainingTime"
				>{{ readAbleTime(remainingTime) }}</time
			>
			<time
				v-if="typeof duration !== 'undefined'"
				:aria-label="ariaAttribution"
				class="element__caption__time element__caption__time--duration"
				>{{ readAbleTime(duration) }}</time
			>
			<time
				v-if="typeof duration !== 'undefined' && typeof pastTime !== 'undefined'"
				class="element__caption__time element__caption__time--fracture"
				>{{ readAbleTime(pastTime) }}/{{ readAbleTime(duration) }}</time
			>
		</figcaption>
	</figure>
</template>

<script>
import { i18n } from '../../tools/i18n';
import { returnReadableTime } from '../../tools/helpers';
export default {
	props: {
		type: String,
		elementTranslation: String,
		mediaId: String,
		mediaActive: Boolean,
		altText: String,
		attribution: String,
		title: [String, Boolean],
		description: [String, Boolean],
		pastTime: Number,
		remainingTime: Number,
		duration: Number, // time in seconds
	},
	methods: {
		readAbleTime(time) {
			return returnReadableTime(time);
		},
	},
	computed: {
		hasPastTime() {
			return typeof pastTime !== 'undefined';
		},
		ariaTitle() {
			return this.title ? `${i18n.t('title')}: ${this.title}` : undefined;
		},
		ariaDescription() {
			return this.description ? `${i18n.t('description')}: ${this.description}` : undefined;
		},
		ariaAttribution() {
			return this.attribution ? `${i18n.t('attribution')}: ${this.attribution}` : undefined;
		},
		ariaDuration() {
			return this.duration ? `${i18n.t('duration')}: ${returnReadableTime(this.duration)}` : undefined;
		},
	},
};
</script>

<style lang="scss">
/****/
</style>
